import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { OivViewerEffects } from './store/oiv-viewer-effects.service';
import { oivViewerFeature } from './store/oiv-viewer.reducer';

export const provideOivViewer = [
    provideState({
        name: oivViewerFeature.name,
        reducer: oivViewerFeature.reducer,
    }),
    provideEffects(OivViewerEffects),
];
